import { useMemo } from 'react';
import { useTranslation } from 'next-i18next';
import { BedroomCount } from 'domain/listing/value-objects';
import { Namespaces } from 'types/locales';
import { formatBedroomCount, type BedroomCountFormat } from './format-bedroom-count';

export interface UseBedroomCountOptions {
  bedrooms: number | null;
  format?: BedroomCountFormat;
}

export interface UseBedroomCountResult {
  formatted: string;
  hasValue: boolean;
}

export function useBedroomCount(options: UseBedroomCountOptions): UseBedroomCountResult {
  const { bedrooms, format = 'short' } = options;
  const { t } = useTranslation(Namespaces.COMMON);

  return useMemo(() => {
    const vo = BedroomCount.from(bedrooms);
    return {
      formatted: formatBedroomCount(vo, format, t),
      hasValue: vo.hasValue,
    };
  }, [bedrooms, format, t]);
}
